module.exports = __webpack_public_path__ + "static/media/cat_tshirts.e1536e01.jpg";